<template>
  <div class="uebersicht">
    <div class="columns">
      <div class="column" style="text-align:left;">

      </div>
      <div class="column">

      </div>
      <div class="column">

      </div>
      <div class="column">
        <b-field>
            <b-input placeholder="Suche..."
                type="search"
                icon="magnify"
                @keyup.native.enter="searchData"
                 v-model="search">
            </b-input>
        </b-field>
      </div>
    </div>
    <b-table class="offers" :data="data" :loading="loading" :backend-pagination="true" :total="total" :current-page="currentPage" :per-page="perPage" :paginated="true" @page-change="onPageChange" checkable hoverable>
      <template slot-scope="props">
        <b-table-column field="id" label="ID" sortable>
            {{ props.row.id }}
        </b-table-column>
        <b-table-column field="orderdate" label="Datum" sortable>
            {{ formatDate(props.row.orderdate) }}
        </b-table-column>
        <b-table-column  field="email" label="Email" sortable>
            {{ props.row.email}}
        </b-table-column>
				<b-table-column field="title" label="Anrede" sortable>
            {{ props.row.title }}
        </b-table-column>
        <b-table-column  field="firstname" label="Vorname" sortable>
            {{ props.row.firstname}}
        </b-table-column>
        <b-table-column  field="lasttname" label="Nachname" sortable>
            {{ props.row.lastname}}
        </b-table-column>
        <b-table-column  field="whiteLabelId" label="White-label" sortable>
            {{ props.row.whiteLabelId}}
        </b-table-column>
        <b-table-column  field="fingerprint" label="Fingerprint" sortable>
            {{ props.row.fingerprint}}
        </b-table-column>
        <b-table-column  field="emailprocessed" label="Email-processed" sortable>
            <b-icon v-if="props.row.emailprocessed"
              icon="check"
              size="is-small">
          </b-icon>
            <b-icon v-if="!props.row.emailprocessed"
              icon="close"
              size="is-small">
          </b-icon>
        </b-table-column>
        <b-table-column  field="zohoprocessed" label="Zoho-processed" sortable>
            <b-icon v-if="props.row.zohoprocessed"
              icon="check"
              size="is-small">
          </b-icon>
            <b-icon v-if="!props.row.zohoprocessed"
              icon="close"
              size="is-small">
          </b-icon>
        </b-table-column>
        <b-table-column  field="mailchimprocessed" label="Mailchimp-processed" sortable>

            <b-icon v-if="props.row.mailchimprocessed"
              icon="check"
              size="is-small">
          </b-icon>
            <b-icon v-if="!props.row.mailchimprocessed"
              icon="close"
              size="is-small">
          </b-icon>
        </b-table-column>
        <b-table-column  field="zohoerror" label="Zoho-error" sortable>

            <b-icon v-if="props.row.zohoerror"
              icon="check"
              size="is-small">
          </b-icon>
            <b-icon v-if="!props.row.zohoerror"
              icon="close"
              size="is-small">
          </b-icon>
        </b-table-column>
        <b-table-column  field="mailchimperror" label="Mailchimp-error" sortable>

            <b-icon v-if="props.row.mailchimperror"
              icon="check"
              size="is-small">
          </b-icon>
            <b-icon v-if="!props.row.mailchimperror"
              icon="close"
              size="is-small">
          </b-icon>
        </b-table-column>
        <!--<b-table-column  field="inuse" label="In use" sortable>
            <b-icon v-if="props.row.inuse"
              icon="check"
              size="is-small">
          </b-icon>
            <b-icon v-if="!props.row.inuse"
              icon="close"
              size="is-small">
          </b-icon>
        </b-table-column>-->

      <b-table-column  custom-key="actions">
        <div style="width:60px;">
        <button  style="border:0px;margin-right:7px;" class="button is-small" @click="editItem(props.row)">
        <b-icon type="is-primary" icon="pencil"></b-icon>
        </button>
         <button style="border:0px;" class="button is-small" @click="deleteItem(props.row)">
        <b-icon type="is-danger" icon="delete"></b-icon>
        </button>
      </div>
      </b-table-column>
    </template>

    <!--<template slot="detail" slot-scope="props">
      <tabledetail :row="props.row"></tabledetail>
    </template>-->

    <template slot="empty">
              <section class="section">
                  <div class="content has-text-grey has-text-centered">
                      <p>
                          <b-icon
                              icon="emoticon-sad"
                              size="is-large">
                          </b-icon>
                      </p>
                      <p>Keine Anfragen gefunden.</p>
                  </div>
              </section>
          </template>

      </b-table>
    </b-table>
  </div>
</template>

<script>
// @ is an alias to /src

const axios = require('axios');
var moment = require('moment');

export default {
  name: "home",
  components: {
  //  HelloWorld
},
data() {
      return {
          search: "",
          loading: true,
          data: [],
          //allData: [], //Für Suchfunktion nötig,
          currentPage: 1,
          perPage: 40,
          total: 0
      }
  },
  watch: {
    search: function(val) {
      console.log("Suche2");
      console.log(val);
      //console.log(this.allData);
      //val = val.toLowerCase();

      //if (val.length > 1) {
      //  this.currentPage = 1;
      //  this.loadItems();
      //}

    },
  },
  mounted: function () {
    this.loadItems();
  },
  methods: {
    searchData: function() {
      console.log("searchData");
      this.currentPage = 1;
      this.loadItems();
    },
    onPageChange: function(newPage) {
      console.log(newPage);
      this.currentPage = newPage;
      this.loadItems();
    },
    loadItems: function() {
      //Get-Game
      var _this = this;
      var search = _this.search
      _this.loading = true;
      axios.get('/api/offers?_perPage='+_this.perPage+'&_page='+_this.currentPage+'&_txtSearch='+search.toLowerCase(), {
        withCredentials: true,
      })
      .then(function (response) {
        console.log(response.headers["x-total-count"]);
        _this.data = response.data;
        //_this.allData = response.data;
        _this.total = response.headers["x-total-count"];
        _this.loading = false;
      })
      .catch(function (error) {
        console.log(error);
          _this.loading = false;
      })
      .then(function () {
        // always executed
      });

    },
    deleteItem: function(item) {
      console.log("DELETE "+item.id);
      console.log(this.search);
      var vm = this;
      this.$buefy.dialog.confirm({
        title: 'Angebot löschen',
        message: 'Soll das Angebot wirklich gelöscht werden?',
        confirmText: 'Angebot löschen',
        type: 'is-danger',
        hasIcon: true,
        cancelText: 'Abbrechen',
        onConfirm: function() {
          console.log(vm.search);
          axios.delete('/api/offers/'+item.id, {
            withCredentials: true,
          })
          .then(function (response) {
            console.log(response.data);
             vm.$buefy.toast.open('Das Angebot wurde gelöscht!');
             vm.loadItems();
          })
          .catch(function (error) {

          })
          .then(function () {
            // always executed
          });

         }
       })
    },

    editItem: function(item) {
      console.log("EDIT "+item.id);
      this.$router.push({ name: 'editoffer', params: { id: item.id } })
    },
    formatDate: function(timestamp) {
      return moment(timestamp).format("DD.MM.YYYY HH:mm");
    //  return new Date(timestamp).toLocaleDateString("de-DE")
    }
  }
};
</script>
<style>
.b-table.offers .table {
  font-size: 12px;
}
.b-table.offers .table td, .b-table.offers .table th {
  padding: 4px 4px;
}
</style>
